import { useMemo } from 'react'

import { createMediaDeviceObserver } from '@livekit/components-core'

import { useObservableState } from '@/src/hooks/internal'

/**
 * The `useMediaDevices` hook returns the list of media devices of a given kind.
 *
 * @example
 * ```tsx
 * const videoDevices = useMediaDevices({ kind: 'videoinput' });
 * const audioDevices = useMediaDevices({ kind: 'audioinput' });
 * ```
 * @public
 */
export function useMediaDevices({
  kind,
  onError,
}: {
  kind: MediaDeviceKind
  onError?: (e: Error) => void
}) {
  const deviceObserver = useMemo(() => createMediaDeviceObserver(kind, onError), [kind, onError])
  const devices = useObservableState(deviceObserver, [] as MediaDeviceInfo[])
  return devices
}
